import _ from 'lodash';
export var AdvancedSection;
(function (AdvancedSection) {
    AdvancedSection["DISPLAY"] = "chart.chartEditor.chartConfigurator.DISPLAY_SECTION";
    AdvancedSection["CORTEX"] = "charts.chartEditor.section.CORTEX";
    AdvancedSection["DATA_OPTIONS"] = "charts.chartEditor.section.DATA_OPTIONS";
    AdvancedSection["SUMMARY"] = "chart.chartEditor.chartConfigurator.SUMMARY_SECTION";
    AdvancedSection["VALUES"] = "chart.chartEditor.chartConfigurator.VALUES_SECTION";
    AdvancedSection["TOOLTIP"] = "chart.chartEditor.chartConfigurator.TOOLTIP";
})(AdvancedSection || (AdvancedSection = {}));
export const getCustomPropSectionKey = (section) => section !== null && section !== void 0 ? section : AdvancedSection.DISPLAY;
export const getCustomPropsConfig = (config) => {
    return _.get(config, 'advanced.display.chartSpecific.customProps');
};
export class AllowedChartConfigurationsConfig {
    constructor(conditionalFormatEditorParams, geoProjectionType, allowAxisCustomization, showYAxisAsPercent, zoomPanStateToggle, showDataLabels, showStackLabels, showDetailedLabels, showAxes, showRoundedNumbers, showColorAxis, xAxisRange, yAxisRange, regressionLine, transposeXY, allowColorChange, supportColumnLevelColorChange, configureColorForXAttrs, configureColorForYAttrs, configureColorForRadialAttrs, markersEnabled, gradientEnabled, advanced, excludeNullValues, gridLines, gridLineConfig, showYAxisLinkingOption, shouldOnlyContainOneYAxis, optionalXAxisColumns, useCustomColorSelector, renameAxis, repositionAxis, conditionalFormatting, allowEnhancedConditionalFormatting, strokeWidth, isSummaryModeAllowed, onlyTimeSeriesOnXAxis, allowMultipleColumnsOnYAxis, allowAttributesInPivotData, disableSortForAttributeColumns, allowChartCustomisation, allowNumberFormatting, allowSortFormatOption, measureNameValueColumns, allowDynamicSettings) {
        this.conditionalFormatEditorParams = conditionalFormatEditorParams;
        this.geoProjectionType = geoProjectionType;
        this.allowAxisCustomization = allowAxisCustomization;
        this.showYAxisAsPercent = showYAxisAsPercent;
        this.zoomPanStateToggle = zoomPanStateToggle;
        this.showDataLabels = showDataLabels;
        this.showStackLabels = showStackLabels;
        this.showDetailedLabels = showDetailedLabels;
        this.showAxes = showAxes;
        this.showRoundedNumbers = showRoundedNumbers;
        this.showColorAxis = showColorAxis;
        this.xAxisRange = xAxisRange;
        this.yAxisRange = yAxisRange;
        this.regressionLine = regressionLine;
        this.transposeXY = transposeXY;
        this.allowColorChange = allowColorChange;
        this.supportColumnLevelColorChange = supportColumnLevelColorChange;
        this.configureColorForXAttrs = configureColorForXAttrs;
        this.configureColorForYAttrs = configureColorForYAttrs;
        this.configureColorForRadialAttrs = configureColorForRadialAttrs;
        this.markersEnabled = markersEnabled;
        this.gradientEnabled = gradientEnabled;
        this.advanced = advanced;
        this.excludeNullValues = excludeNullValues;
        this.gridLines = gridLines;
        this.gridLineConfig = gridLineConfig;
        this.showYAxisLinkingOption = showYAxisLinkingOption;
        this.shouldOnlyContainOneYAxis = shouldOnlyContainOneYAxis;
        this.optionalXAxisColumns = optionalXAxisColumns;
        this.useCustomColorSelector = useCustomColorSelector;
        this.renameAxis = renameAxis;
        this.repositionAxis = repositionAxis;
        this.conditionalFormatting = conditionalFormatting;
        this.allowEnhancedConditionalFormatting = allowEnhancedConditionalFormatting;
        this.strokeWidth = strokeWidth;
        this.isSummaryModeAllowed = isSummaryModeAllowed;
        this.onlyTimeSeriesOnXAxis = onlyTimeSeriesOnXAxis;
        this.allowMultipleColumnsOnYAxis = allowMultipleColumnsOnYAxis;
        this.allowAttributesInPivotData = allowAttributesInPivotData;
        this.disableSortForAttributeColumns = disableSortForAttributeColumns;
        this.allowChartCustomisation = allowChartCustomisation;
        this.allowNumberFormatting = allowNumberFormatting;
        this.allowSortFormatOption = allowSortFormatOption;
        this.measureNameValueColumns = measureNameValueColumns;
        this.allowDynamicSettings = allowDynamicSettings;
    }
}
//# sourceMappingURL=chart-allowed-configurations-config.js.map